export const constants = {
    uri: {
        whatsApp_installationGuide: 'https://alia-organization.gitbook.io/onboarding-to-javna-cpaas-platform/',
        whatsApp_commercePolicy: 'https://www.whatsapp.com/legal/commerce-policy',
        whatsApp_businessTerms: 'https://www.whatsapp.com/legal/business-terms',
        whatsApp_conversationTypes: 'https://developers.facebook.com/docs/whatsapp/conversation-types',
        whatsApp_categoriesGuide: 'https://developers.facebook.com/docs/whatsapp/updates-to-pricing/new-template-guidelines',
        whatsApp_AuthenticationGuide: 'https://developers.facebook.com/docs/whatsapp/business-management-api/authentication-templates/',

    },
    petterns: {
        invalidTemplateName: /[^a-zA-Z0-9_]/g,
        templateVariable: /\{\{[1-9]\d*\}\}/g,
        validNumber: /^[0-9\b]+$/,
        validFullPhoneNumber: /^(?:\+|00)?[\d\s\-()]{6,20}$/,
        validUrl: /^(http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/i,
        validEmail: /^[\w-._+]+@([\w-]+\.)+[\w-]{2,4}$/,
    }
}